import { render, staticRenderFns } from "./FavsPanierUser.vue?vue&type=template&id=1efb982e&scoped=true&"
import script from "./FavsPanierUser.vue?vue&type=script&lang=js&"
export * from "./FavsPanierUser.vue?vue&type=script&lang=js&"
import style0 from "./FavsPanierUser.vue?vue&type=style&index=0&id=1efb982e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efb982e",
  null
  
)

export default component.exports